const rapporterSitePaths = {
  shortUrl: "/rapporter",
  ventilstillinger: {
    shortUrl: "/rapporter/ventilstillinger",
    oversikt: "/rapporter/ventilstillinger/oversikt",
    detalj: {
      bilde: "/rapporter/ventilstillinger/:id/bilder/:bildeId",
      route: "/rapporter/ventilstillinger/:id",
      getUrl: (ventilstillingId) =>
        `/rapporter/ventilstillinger/${ventilstillingId}`,
      utskrift: "/rapporter/ventilstillinger/:id/utskrift",
      ileggelse: {
        detalj: {
          route: "/rapporter/ventilstillinger/:id/ileggelse/:id",
          getUrl: (ventilstillingId, ileggelseId) =>
            `/rapporter/ventilstillinger/${ventilstillingId}/ileggelse/${ileggelseId}`,
          rediger:
            "/rapporter/ventilstillinger/:id/ileggelse/:id/bilder/:bildeId/rediger",
          bilde:
            "/rapporter/ventilstillinger/:id/ileggelse/:id/bilder/:bildeId",
          svarUtHistorikk:
            "/rapporter/ventilstillinger/:id/ileggelse/:id/svar-ut/:svarUtId/historikk",
        },
      },
    },
    ileggelse: {
      detalj: {
        route: "/rapporter/ventilstillinger/ileggelse/:id",
        getUrl: (ileggelseId) =>
          `/rapporter/ventilstillinger/ileggelse/${ileggelseId}`,
        rediger:
          "/rapporter/ventilstillinger/ileggelse/:id/bilder/:bildeId/rediger",
        bilde: "/rapporter/ventilstillinger/ileggelse/:id/bilder/:bildeId",
        svarUtHistorikk:
          "/rapporter/ventilstillinger/ileggelse/:id/svar-ut/:svarUtId/historikk",
      },
    },
  },
  skiftlogg: {
    shortUrl: "/rapporter/skiftlogg",
    oversikt: "/rapporter/skiftlogg/oversikt",
  },
  piggdekkontroller: {
    shortUrl: "/rapporter/piggdekkontroller",
    oversikt: "/rapporter/piggdekkontroller/oversikt",
  },
  klager: {
    shortUrl: "/rapporter/klager",
    oversikt: "/rapporter/klager/oversikt",
  },
  ubetalteIleggelser: {
    shortUrl: "/rapporter/ubetalte-ileggelser",
    oversikt: "/rapporter/ubetalte-ileggelser/oversikt",
    detalj: {
      matcher:
        "/rapporter/ubetalte-ileggelser/([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})(\\?.*)?$",
      route: "/rapporter/ubetalte-ileggelser/:kjoretoyId",
      getUrl: (kjoretoyId) => `/rapporter/ubetalte-ileggelser/${kjoretoyId}`,
      ileggelser: {
        matcher:
          "/rapporter/ubetalte-ileggelser/([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})/ileggelser/([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})(\\?.*)?$",
        route: "/rapporter/ubetalte-ileggelser/:kjoretoyId/ileggelser/:id",
        getUrl: (kjoretoyId, ileggelseId) =>
          `/rapporter/ubetalte-ileggelser/${kjoretoyId}/ileggelser/${ileggelseId}`,
      },
    },
  },
  uferdigstilteKlagesaker: {
    shortUrl: "/rapporter/uferdigstilte-klagesaker",
    oversikt: "/rapporter/uferdigstilte-klagesaker/oversikt",
  },
  juridiskSaksbehandler: {
    shortUrl: "/rapporter/saksbehandler",
    oversikt: "/rapporter/saksbehandler/oversikt",
  },
  antallIleggelserPerIleggelsetype: {
    shortUrl: "/rapporter/antall-ileggelser-per-ileggelsetype",
    oversikt: "/rapporter/antall-ileggelser-per-ileggelsetype/oversikt",
  },
  makuleringer: {
    shortUrl: "/rapporter/makuleringer",
    oversikt: "/rapporter/makuleringer/oversikt",
  },
  aarsrapport: {
    shortUrl: "/rapporter/aarsrapport",
    oversikt: "/rapporter/aarsrapport/oversikt",
  },
};

export default rapporterSitePaths;
